<template>
  <div class="route-search-inputs">
    <div class="selectButton" @click="onClickSpotSelect">
      <p><img src="@/assets/search.svg" />スポット名</p>
    </div>
    <div class="modal" v-show="openSelectSpotDialog">
      <TitleArea text="観光" @click-close="onClickClose" :showReturn="true" />
      <div class="modal-inner">
        <div class="input-box">
          <InputSearchBox
            text="スポット名"
            v-model="inputSpot"
            @keydown="onKeydown"
          />
          <ul class="area-list">
            <li class="current-spot" @click="onClickNearBySearch">
              <img
                src="@/assets/arrow.svg"
                alt="現在地"
                width="16px"
                height="16px"
              />
              現在地周辺
            </li>
            <li @click="onClickArea" class="other">
              <p>
                地域から探す
                <img
                  class="triangle"
                  :class="{ isExpand: showAreaList }"
                  src="@/assets/chevron.svg"
                />
              </p>
            </li>
            <li
              class="other"
              v-for="item in list"
              v-show="showAreaList"
              :key="item.id"
              @click="onClickSpot(item.name)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import TitleArea from "@/components/Atoms/TitleArea";
import TextLinkInline from "@/components/Atoms/TextLinkInline";
import InputSearchBox from "@/components/Atoms/InputSearchBox";

export default {
  name: "route-search-inputs",
  components: {
    TextLinkInline,
    InputSearchBox,
    TitleArea,
  },
  computed: {
    inputCheck() {
      return !!(
        this.inputTime !== "" &&
        this.inputDeparture !== "" &&
        this.inputDestionation !== ""
      );
    },
  },
  props: {
    list: { type: Array, required: true },
    openSelectSpotDialog: { type: Boolean, required: true },
  },
  data() {
    return {
      inputSpot: "",
      selectSpot: "",
      showAreaList: false,
    };
  },
  methods: {
    ...mapMutations(["setSearch"]),
    onClickSpotSelect() {
      this.$emit("click-open-select-spot");
    },
    onClickClose() {
      this.$emit("click-close-select-spot");
    },
    onClickArea() {
      this.showAreaList = !this.showAreaList;
    },
    onClickNearBySearch() {
      const param = {
        departure: "現在地",
        destination: "現在地",
      };
      this.$emit("click-search", param);
    },
    onClickSpot(e) {
      this.selectSpot = e;
      this.onClickSearch();
    },
    onKeydown(e) {
      this.inputSpot = e;
      this.selectSpot = e;
      this.onClickSearch();
    },
    onClickSearch() {
      const param = {
        departure: this.selectSpot,
        destination: this.selectSpot,
      };
      this.$emit("click-search", param);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.route-search-inputs {
  padding: 0 0.5rem;
}

.input-box {
  width: 100%;
  input {
    background: #f6f6f6;
  }
}

.area-list {
  list-style: none;
  padding: 0;
  margin-bottom: 5rem;
  li {
    padding: 1rem 1rem;
    border-bottom: 1px solid #ccc;
    p {
      margin: 0;
      position: relative;
      display: inline-flex;
      align-items: center;
      width: 100%;
    }
    .triangle {
      position: absolute;
      right: 0.5rem;
      font-size: 1.2rem;
      &.isExpand {
        transform: rotate(180deg);
      }
    }
  }
  .other {
    padding-left: 2.4rem;
  }
}
.current-spot {
  display: flex;
  align-items: center;
  right: 0.5rem;
  top: 0.6rem;
  img {
    width: 1rem;
    margin-right: 0.5rem;
  }
}

.selectButton {
  background: #f6f6f6;
  border-radius: 1rem;
  padding: 0.25rem 1rem;
  margin: 0.5rem 0;
  font-size: 1rem;
  display: flex;
  align-items: center;
  img {
    width: 1rem;
    margin-right: 0.5rem;
  }
  p {
    margin: 0;
    display: inline-flex;
    justify-content: center;
  }
}
.modal {
  background-color: white;
  z-index: 3;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  .modal-inner {
    padding: 3rem 0.25rem 0;
    height: calc(100% - 5.5rem);
    overflow: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/RouteSearchSpot.vue